import { render, staticRenderFns } from "./jxzytj.vue?vue&type=template&id=60de9dc5&scoped=true"
import script from "./jxzytj.vue?vue&type=script&lang=js"
export * from "./jxzytj.vue?vue&type=script&lang=js"
import style0 from "./jxzytj.vue?vue&type=style&index=0&id=60de9dc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de9dc5",
  null
  
)

export default component.exports